import './FormListItem.scss';

export { default } from './FormListItem';
